import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const { id, currentStatus, steps } = {
  id: null,
  currentStatus: 'new',
  steps: {
    intro: {
      step: 'Giriş Bilgileri',
      email: null,
      fullname: null,
      phoneNumber: null,
      companyName: null,
      isCompleted: false,
    },
    questions: {
      step: 'Sizi Tanıyalım',
      serviceRegions: [],
      location: {
        type: 'billing',
        country: {
          code: 'TR',
          title: {
            tr: 'TÜRKİYE',
            en: 'TURKEY',
          },
        },
        city: null,
        county: null,
        district: null,
        zipCode: null,
        street: null,
        geoLocation: {
          latitude: 38.963745,
          longitude: 35.243322,
        },
      },
      questions: [],
      isCompleted: false,
    },
    vehicleInfo: {
      step: 'Araç Bilgileri',
      vehicles: [],
      isCompleted: false,
    },
    companyInformation: {
      step: 'Firma Bilgileri',
      taxInfo: {
        officialName: null,
        tin: null,
        taxOffice: null,
      },
      isCompleted: false,
    },
    contract: {
      step: 'Sözleşme',
      contractDocumentUrl: process.env.VUE_APP_SELLER_CONTRACT_URL,
      bankAccounts: [
        {
          primary: true,
          name: null,
          iban: null,
        },
      ],
      contractMedias: [],
      taxMedias: [],
      commercialRegistrationMedias: [],
      chamberRegistrationMedias: [],
      signatureCircularMedias: [],
      isCompleted: false,
    },
  },
};

export default {
  namespaced: true,
  state: {
    defaultSteps: steps,
    id,
    currentStatus,
    ...steps,
  },
  actions,
  getters,
  mutations,
};
